import { rest } from 'msw';

const mockPermissions = [
  {
    id: 'test',
    name: 'Test permission',
    label_es: 'Prueba',
    label_en: 'Test',
    label_pr: 'Teste'
  }
];
const permissionHandler = [
  rest.get('*/us/permission', (req, res, ctx) => {
    return res(ctx.delay(), ctx.status(200), ctx.json(mockPermissions));
  })
];

const handlers: any = [...permissionHandler];

export default handlers;
